import React from "react";
import { Star } from "lucide-react";
import CERT_TR from "@/i18n_cert";

const DATE_LOCALE = { sk: "sk-SK", en: "en-GB", cs: "cs-CZ", de: "de-DE", pl: "pl-PL" };

/**
 * Tiny gold medal shown next to a lifetime SauberEko® certificate holder's name
 * in community chat. Native `title` tooltip is used so it works on mobile + desktop.
 * Renders nothing if `since` is missing.
 */
export default function LifetimeMedal({ since, lang = "sk", size = "sm" }) {
  if (!since) return null;
  const ct = CERT_TR[lang] || CERT_TR.sk;
  let dateStr = "";
  try {
    dateStr = new Date(since).toLocaleDateString(DATE_LOCALE[lang] || "sk-SK", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  } catch {
    dateStr = since;
  }
  const tooltip = `${ct.lifetime_label} · ${ct.lifetime_brand} · ${ct.lifetime_since} ${dateStr}`;
  const iconClass = size === "xs" ? "w-3 h-3" : size === "lg" ? "w-4 h-4" : "w-3.5 h-3.5";
  const wrapClass =
    size === "xs"
      ? "w-4 h-4"
      : size === "lg"
        ? "w-6 h-6"
        : "w-5 h-5";
  return (
    <span
      data-testid="chat-lifetime-medal"
      aria-label={tooltip}
      title={tooltip}
      className={`${wrapClass} inline-flex items-center justify-center rounded-full bg-gradient-to-br from-amber-300 via-yellow-200 to-amber-500 ring-1 ring-amber-200/60 shadow-[0_0_8px_-1px_rgba(251,191,36,0.7)] flex-shrink-0`}
    >
      <Star className={`${iconClass} text-amber-900`} strokeWidth={2.5} fill="currentColor" />
    </span>
  );
}
